import { Link, useOutletContext } from 'react-router-dom';
import { CheckCircle2, ChevronRight } from 'lucide-react';
import { useCategories } from '@/lib/vendors';
import type { Program } from '@/lib/types';
import { Badge, Card, PageHeader, Spinner } from '@/components/ui/misc';

export function VendorsPage() {
  const program = useOutletContext<Program>();
  const q = useCategories(program.id);
  const admin = program.membership.role === 'ADMIN';
  if (!q.data) return <Spinner className="h-64" />;
  return (
    <div className="mx-auto max-w-[1100px] px-6 py-6">
      <PageHeader
        title="Vendors"
        description="The Phase 2 evaluation across the eight PA categories. Scores stay hidden from other evaluators until each person submits."
      />
      {!q.data.length ? (
        <Card className="p-6 text-sm text-muted">
          {admin
            ? 'No categories yet.'
            : 'Nothing to show yet. Categories appear here when you are named an evaluator or once results are in.'}
        </Card>
      ) : (
        <Card className="divide-y divide-border p-0">
          {q.data.map((c) => (
            <Link
              key={c.id}
              to={c.id}
              className="flex flex-wrap items-center gap-x-6 gap-y-1 px-4 py-3 text-sm hover:bg-surface-2/60"
            >
              <span className="min-w-56 flex-1 font-medium">{c.name}</span>
              <span className="text-xs text-muted">
                {c.vendors} vendor{c.vendors === 1 ? '' : 's'} · {c.criteria} criteria
              </span>
              <span className="text-xs text-muted">
                {c.submitted} of {c.evaluators} evaluator{c.evaluators === 1 ? '' : 's'} submitted
              </span>
              {c.isEvaluator &&
                (c.iSubmitted ? (
                  <Badge tone="ok">
                    <CheckCircle2 className="mr-1 inline size-3" /> You submitted
                  </Badge>
                ) : (
                  <Badge tone="warn">Your scores are due</Badge>
                ))}
              <ChevronRight className="size-4 text-muted" />
            </Link>
          ))}
        </Card>
      )}
    </div>
  );
}
